
<script>
import { notify } from '@/helpers/notify' 
import Loader from "@/components/widgets/loader.vue";

export default {
    name: 'VericiTransaction',
    props:[
        "openModal",
        "data"
    ],
    components: {
        Loader
    },
    data() {
        return {
            submitted: false,
            form: {},
          
            ertele: false,
            loading:false,
            searchResult: [],
            basket: [],
            basketToplam : 0,
            searchModel: '',
            stockList: [],
            demont: [],
            timeout: null,
        };
    },
    computed:{ 
        ModalTitle(){
            return `İşleme Al `
        },
    },
    watch:{
        openModal(){
            this.form = {}
            this.stockList = []
            this.demont = []
            this.basket = []
            this.searchResult = []
            this.searchModel = ''
            this.basketToplam = 0
            this.getStockList()
        }
    },
    methods: {
        getStockList(){
            const url = `transmitter/stocks/${this.data.transmitter_id}`
            this.$http.post(url).then((response) => {
                this.stockList = response.data
           });
        },

        close(){
            this.$parent.$bvModal.hide('verici_transaction')
        },
        
        handleSubmit(){
        
            this.$http.post('/transmitter/faults/complete', {
                id: this.data.id,
                transmitter_id: this.data.transmitter_id,
                demonts: this.demont,
                basket: this.basket,
                note: this.form.description
            })
            .then((response) => {
                if (response.data.code != 100) {
                    return notify.error(response.data.message)
                }
                this.$emit('loadItems');
                notify.success(response.data.message)
                this.close()
            })
        },
        postpone(data){
            this.ertele = data == 1 ? true : false
        },
        debouncedProduct() {
          
          if (this.timeout) {
              clearTimeout(this.timeout);
          }
         
          this.timeout = setTimeout(() => {
              this.product();
          }, 1000);
        },
        product() {
            this.searchResult = []
            this.$http.post('stock', { search: this.searchModel }).then((data) => {
                this.loading = false
                if (data.data.length == 0) {
                  return notify.error('Stokta ürün bulunmamaktadır.')
              }
                this.searchResult = data.data
           });
        },
        addBasket(sr) {
            this.searchModel = ''
            this.searchResult= []
            this.basket.push({ ...sr, amount: 1 })
            this.calc()
         
        },
        calc() {
            let toplam = 0
            this.basket.map(item => {
                toplam += parseFloat(item.price) * (item.group_id == 'ka' ? item.amount : 1)
            })
            this.basketToplam = toplam
        },
        demontaj(id) {
            const index = this.demont.indexOf(id);
            if (index === -1) {
                this.demont.push(id);
            } else {
                this.demont.splice(index, 1);
            }
        },
        preventEnter(event) {
            if (event.key === 'Enter') {
                event.preventDefault();
            }
        },

        listRmv(idx){
            this.basket = this.basket.splice(idx,0)
        }
    },
};
</script>

<template>
<b-modal id="verici_transaction" :title="ModalTitle"  no-close-on-backdrop hide-footer>
    <form @submit.prevent="handleSubmit" enctype="multipart/form-data">
        <Loader :loading="true" :load="loading">
            <div class="row mb-1">
               <div class="col-12 mb-1">    
                    <h6 class="mb-2">Eklenecek Cihaz/Malzemeler Ara</h6>
                    <div class="row">
                        <div class="col-12 mb-1">
                            <div class="">
                                <input 
                                    class="form-control" 
                                    type="text" 
                                    v-model="searchModel" 
                                    @keypress="preventEnter"
                                    @keyup="debouncedProduct">
                            </div>
                        </div>
                    </div>
                    <div class="row" v-if="searchResult.length > 0">
                        <div class="col-12">
                            <table class="table table-sm">
                                <tbody>
                                    <tr v-for="(sr,i) in searchResult" :key="i">
                                        <td><button type="button" @click="addBasket(sr)" class="btn btn-sm btn-success">Seç</button></td>
                                        <td>{{  sr.name }}</td>
                                        <td>{{  sr.stock_group_name }}</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>

           <div class="row mb-1">
                <div class="col-md-12">
                    <table class="table table-sm table-bordered">
                        <thead>
                            <tr>
                                <th colspan="5">
                                    <h6 class="mb-0 text-center text-danger">Pop Noktası Stoğu</h6>
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(stck,i) in stockList" :key="i">
                                <td>{{ stck.stock_group_name }}</td>
                                <td>{{ stck.name }}</td>
                                <td>{{ stck.amount }} {{ stck.unit }}</td>
                                <td style="width:50px">
                                    <button 
                                        class="btn btn-sm" 
                                        :class="demont.includes(stck.id) ? 'btn-success' : 'btn-danger'" 
                                        type="button" 
                                        @click="demontaj(stck.id)">
                                    <span v-if="demont.includes(stck.id)">
                                        <i class="bx bx-check"></i>
                                    </span>
                                    <span v-else>
                                        Sök
                                    </span>
                                    </button>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>

            <!--<div class="row mb-1 mt-3">
                <div class="col-md-12">
                    <table class="table table-sm table-bordered">
                        <tbody>
                            <tr>
                                <td>
                                    Poe
                                </td>
                                <td style="width:50px">
                                    <button 
                                        class="btn btn-sm" 
                                        :class="demont.includes('poe') ? 'btn-success' : 'btn-danger'" 
                                        type="button" 
                                        @click="demontaj('poe')">
                                    <span v-if="demont.includes('poe')">
                                        <i class="bx bx-check"></i>
                                    </span>
                                    <span v-else>
                                        Sök
                                    </span>
                                    </button>
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    Adaptör
                                </td>
                                <td style="width:50px">
                                    <button 
                                        class="btn btn-sm" 
                                        :class="demont.includes('adaptor') ? 'btn-success' : 'btn-danger'" 
                                        type="button" 
                                        @click="demontaj('adaptor')">
                                    <span v-if="demont.includes('adaptor')">
                                        <i class="bx bx-check"></i>
                                    </span>
                                    <span v-else>
                                        Sök
                                    </span>
                                    </button>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>-->


            <div class="row mb-1 mt-3" v-if="basket.length > 0">
               <div class="col-12 mb-1">    
                    <div class="row">
                        <div class="col-12">
                            <table class="table table-sm table-hover table-bordered">
                                <thead>
                                    <tr>
                                        <th colspan="5">
                                            <h6 class="mb-0 text-center text-primary">Seçilen Yeni Eklenecek Cihaz/Malzemeler</h6>
                                        </th>
                                    </tr>
                                </thead>
                                <thead>
                                    <tr>
                                        <th></th>
                                        <th>Stok İsim</th>
                                        <th>Seri No</th>
                                        <th>Adet</th>
                                        <th></th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="(sr,i) in basket" :key="i">
                                        <td>{{ i+1 }}</td>
                                        <td>{{ sr.stock_group_name }}</td>
                                        <td>{{ sr.name }}</td>
                                        <td>
                                            <input 
                                                v-if="sr.group_id == 'ka'" 
                                                @keyup="calc()" 
                                                type="number" 
                                                v-model="sr.amount"
                                                style="width:50px">
                                            <span v-else>1</span>
                                        </td>
                                        <td><button type="button" class="btn btn-danger btn-sm" @click="listRmv(i)">X</button></td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>

        <div v-if="ertele">
            <div class="row d-flex flex-wrap mb-3">
                <div class="col-xl-12">
                    <div class="mb-3">
                        <label for="desc">Erteleme Nedeni</label>
                        <textarea id="desc" type="text" class="form-control" v-model="form.description" ></textarea>
                    </div>
                </div>
            </div>     
        </div>
        <hr>
        <div class="d-flex justify-content-between mt-3">
            <b-button type="button"  variant="light" @click="postpone('2')" v-if="ertele">Geri Dön</b-button>
            <b-button type="button"  variant="light" @click="close()"  v-if="!ertele">Vazgeç</b-button>
            <b-button type="button"  variant="warning" @click="postpone('1')" v-if="!ertele">Ertele</b-button>
            <b-button type="submit" variant="success" v-if="ertele">Kaydet</b-button>
            <b-button 
                v-if="!ertele"
                type="submit" 
                variant="success" 
                class="ms-1"
                >Tamamla
            </b-button>
        </div>
        </Loader>
    </form>
</b-modal>
</template>
